import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { ragStatusWithDesc } from '../../../enums/ragStatus';

export default function RagStatusPicker(prop) {
  const { selectedItem, onChange } = prop;

  return (
    <Select multiple={false} onChange={e => onChange(e.target.value)} value={selectedItem} autoWidth>
      {ragStatusWithDesc &&
        ragStatusWithDesc.map(visitPriorityValue => (
          <MenuItem button key={visitPriorityValue.id} value={visitPriorityValue}>
            {[visitPriorityValue.description]}
          </MenuItem>
        ))}
    </Select>
  );
}
